











import { Component, Model, Mixins, Watch } from "vue-property-decorator";
import FormMixin from "@/fit-ui/common/mixins/formMixin";
import FitIcon from '../../icon/index';
@Component({
  components:{
    FitIcon
  }
})
export default class FitCheckbox extends Mixins(FormMixin) {
  @Model("change") value;
  @Watch("value")
  onValueChange() {
    this.notify("change", this.value);
  }
}
